var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GamePane",
    {
      attrs: { product: "cockfight", wide: _vm.wide },
      scopedSlots: _vm._u(
        [
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "cockfight-pane__identity" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.arena.code))]),
                  _vm.arenaName
                    ? _c("span", { staticClass: "cockfight-pane__name" }, [
                        _vm._v("· " + _vm._s(_vm.arenaName)),
                      ])
                    : _vm._e(),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "video",
            fn: function () {
              return [
                _c("CockfightVideo", { attrs: { "arena-id": _vm.arena.id } }),
              ]
            },
            proxy: true,
          },
          {
            key: "info",
            fn: function () {
              return [
                _c("GameStatus", {
                  staticClass: "cockfight-pane__status",
                  attrs: { active: _vm.active, "show-arenas": false },
                  on: {
                    jackpotCollectPopup: function ($event) {
                      return _vm.$emit("jackpot")
                    },
                    jackpotPhysicalPopup: function ($event) {
                      return _vm.$emit("jackpot-physical")
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          _vm.wide
            ? {
                key: "aside",
                fn: function () {
                  return [
                    _vm.chartFights && _vm.chartFights.length > 0
                      ? _c("Charts", {
                          staticClass: "cockfight-pane__roads",
                          attrs: { fluid: "" },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              }
            : null,
          !_vm.wide
            ? {
                key: "selector",
                fn: function () {
                  return [
                    _c("ArenaChips", {
                      attrs: { items: _vm.arenaItems },
                      on: {
                        select: function ($event) {
                          return _vm.$emit("select-arena", $event)
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c("BetPanel", {
        staticClass: "cockfight-pane__betting",
        class: { "cockfight-pane__betting--wide": _vm.wide },
        attrs: { active: _vm.active, "show-status": false },
        scopedSlots: _vm._u(
          [
            _vm.wide
              ? {
                  key: "under-zone",
                  fn: function () {
                    return [
                      _c("ArenaChips", {
                        staticClass: "cockfight-pane__rail",
                        attrs: { items: _vm.arenaItems },
                        on: {
                          select: function ($event) {
                            return _vm.$emit("select-arena", $event)
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      !_vm.wide && _vm.chartFights && _vm.chartFights.length > 0
        ? _c("Charts", {
            staticClass: "cockfight-pane__roads",
            attrs: { fluid: "" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }